import { FormType } from '../../../form-types';
import { SermorelinFieldAnswers } from '../questions';

const metabolicMorlinConsent: FormType<SermorelinFieldAnswers> = {
  name: 'Sermorelin and Tesamorlin Questionnaire',
  questions: [
    {
      key: 'sermorelin_medicalConditions',
      next: {
        switch: [
          {
            condition: { 'sermorelin_medicalConditions.cancer': true },
            key: 'sermorelin_ineligible'
          },
          {
            condition: { 'sermorelin_medicalConditions.hypothyroidism': true },
            key: 'sermorelin_thyroidControlConsent'
          }
        ],
        els: 'sermorelin_currentMedications_new'
      }
    },
    {
      key: 'sermorelin_thyroidControlConsent',
      next: {
        switch: [
          {
            condition: { 'sermorelin_thyroidControlConsent.non_consent': true },
            key: 'sermorelin_didNotConsent'
          }
        ],
        els: 'sermorelin_currentMedications_new'
      }
    },
    {
      key: 'sermorelin_currentMedications_new',
      next: {
        switch: [
          {
            condition: {
              'sermorelin_currentMedications_new.muscarinic_antagonist': true
            },
            key: 'sermorelin_ineligible'
          },
          {
            condition: {
              'sermorelin_currentMedications_new.somatostatin': true
            },
            key: 'sermorelin_ineligible'
          },
          {
            condition: {
              'sermorelin_currentMedications_new.propylthiouracil': true
            },
            key: 'sermorelin_ineligible'
          }
        ],
        els: 'sermorelin_consent'
      }
    },
    {
      key: 'sermorelin_consent',
      next: {
        switch: [
          {
            condition: { 'sermorelin_consent.non_consent': true },
            key: 'sermorelin_didNotConsent'
          }
        ],
        els: 'sermorelin_complete'
      }
    },
    'sermorelin_ineligible',
    'sermorelin_didNotConsent',
    'sermorelin_complete'
  ]
};

export default metabolicMorlinConsent;
